export const AssessmentExplorerReviewUrl = '/assessments-explorer-review';
export const AssessmentExplorerUrl = '/assessments-explorer';
